import { createContext, useContext } from 'react';

export type MiniModalRedirectContextType = {
  isLoading?: boolean;
  courseSlug?: string;
  s12nSlug?: string;
  s12nProductVariant?: string;
  isProject?: boolean;
};

const MiniModalRedirectContext = createContext<MiniModalRedirectContextType>({});

/**
 * @description information from the URL query params related to the legacy mini modal.
 */
export const useMiniModalRedirectData = () => useContext(MiniModalRedirectContext);

export default MiniModalRedirectContext;
